/**
 * Нормализует название города к единому виду, чтобы объединить варианты
 * записи разными менеджерами:
 *   «ГОРОД Санкт-Петербург», «г. Санкт-Петербург», «г Санкт-Петербург»,
 *   «Санкт-Петербург, Металлострой» → «Санкт-Петербург».
 *
 * Логика:
 *   - берём часть до первой запятой (отбрасываем район/мкр/уточнение);
 *   - срезаем префикс «город» / «гор.» / «г.» / «г »;
 *   - схлопываем повторные пробелы;
 *   - приводим к Title Case (с учётом дефиса) — чтобы регистр не плодил дубли.
 *
 * Пустая/нулевая строка → '' (трактуется вызывающим кодом как «Без города»).
 */
export function normalizeCity(raw: string | null | undefined): string {
  if (!raw) return ''
  let s = (raw.split(',')[0] ?? '').trim()
  if (s === '') return ''
  // Префикс «город»/«г.»/«г » — но не съедаем первую букву у «Гатчина».
  s = s.replace(/^(город\s+|гор\.\s*|г\.\s*|г\s+)/i, '').trim()
  s = s.replace(/\s+/g, ' ')
  if (s === '') return ''
  return s
    .toLocaleLowerCase('ru-RU')
    .split(' ')
    .map((word) =>
      word
        .split('-')
        .map((part) => (part ? part.charAt(0).toLocaleUpperCase('ru-RU') + part.slice(1) : part))
        .join('-'),
    )
    .join(' ')
}
